export default {"src":"/_next/static/media/whitepaper-default.2f1763d7.svg","height":138,"width":133,"blurWidth":0,"blurHeight":0};